import { createAction } from "redux-actions";

import { moduleSlug } from "../../../constants";

export const updateConfigData = createAction(`${moduleSlug}/UPDATE_CONFIG_DATA`);
